export const quotes = [
  {
    text: "生活不是等待暴风雨过去，而是学会在雨中起舞。",
    author: "沃尔特·惠特曼"
  },
  {
    text: "昨天已经过去，明天还未到来，我们只拥有今天。",
    author: "埃莉诺·罗斯福"
  },
  {
    text: "成功不是终点，失败也不是末日，最重要的是继续前进的勇气。",
    author: "温斯顿·丘吉尔"
  },
  {
    text: "你今天的努力，是幸运的伏笔；当下的付出，是明日的花开。",
    author: "佚名"
  },
  {
    text: "世界上最美好的事物，不是用眼睛能看到的，而是用心感受的。",
    author: "海伦·凯勒"
  },
  {
    text: "做你所能做的，用你所拥有的，在你所在的地方。",
    author: "西奥多·罗斯福"
  },
  {
    text: "人生就像骑自行车，想保持平衡就得往前走。",
    author: "阿尔伯特·爱因斯坦"
  },
  {
    text: "星星之火，可以燎原。",
    author: "《尚书》"
  },
  {
    text: "路虽远行则将至，事虽难做则必成。",
    author: "《荀子》"
  },
  {
    text: "山重水复疑无路，柳暗花明又一村。",
    author: "陆游"
  },
  {
    text: "宝剑锋从磨砺出，梅花香自苦寒来。",
    author: "《警世贤文》"
  },
  {
    text: "不积跬步，无以至千里；不积小流，无以成江海。",
    author: "荀子"
  },
  {
    text: "落红不是无情物，化作春泥更护花。",
    author: "龚自珍"
  },
  {
    text: "天行健，君子以自强不息。",
    author: "《周易》"
  },
  {
    text: "海纳百川，有容乃大；壁立千仞，无欲则刚。",
    author: "林则徐"
  },
  {
    text: "长风破浪会有时，直挂云帆济沧海。",
    author: "李白"
  },
  {
    text: "会当凌绝顶，一览众山小。",
    author: "杜甫"
  },
  {
    text: "千里之行，始于足下。",
    author: "老子"
  },
  {
    text: "学而时习之，不亦说乎？",
    author: "孔子"
  },
  {
    text: "非淡泊无以明志，非宁静无以致远。",
    author: "诸葛亮"
  }
]